var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",class:_vm.modifier,attrs:{"src":require("@/assets/images/logo-davidoff.png"),"alt":"Davidoff Cigarette","title":"Davidoff Cigarette"}})}
var staticRenderFns = []

export { render, staticRenderFns }